import { SVGProps } from 'react';

function PlayButton({ ...props }: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 80 80" {...props}>
      <path d="M40,80A40.011,40.011,0,0,1,24.43,3.143a40.01,40.01,0,0,1,31.14,73.713A39.749,39.749,0,0,1,40,80ZM32.863,24a2.883,2.883,0,0,0-1.336.329A2.853,2.853,0,0,0,30,26.864V53.135a2.853,2.853,0,0,0,1.538,2.538A2.882,2.882,0,0,0,32.867,56a2.836,2.836,0,0,0,1.63-.512L53.924,42.019a2.562,2.562,0,0,0-.011-4.22L34.483,24.5A2.866,2.866,0,0,0,32.863,24Z" />
    </svg>
  );
}

export default PlayButton;
